import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { LocaleContext } from 'libs.nucleus';
import { fetchNotificationTemplates } from './helpers/fetch_notification_templates.helpers';
import { useCurrentEnvironment } from '../../hooks/use_current_environment';
/**
 * Loads the study notification template catalog for the Send notification modal
 * (`GET c_sites/:siteId/c_notification_templates`).
 */
export const useNotificationTemplates = (siteId, options = {}) => {
    const { enabled = true } = options;
    const { environment } = useCurrentEnvironment();
    const locale = useContext(LocaleContext);
    const { data, isLoading, isError } = useQuery({
        queryKey: ['siteNotificationTemplates', environment?.id, siteId, locale],
        queryFn: async () => {
            if (!environment || !siteId) {
                return [];
            }
            return fetchNotificationTemplates({ environment, siteId, locale });
        },
        enabled: enabled && !!environment && !!siteId,
    });
    return {
        templates: data ?? [],
        isLoading,
        isError,
    };
};
